<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="queryForm"
        class="queryFormClass"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('receivablePayable.TicketNumber')">
              <el-input
                v-model="queryForm.params.businessNumber"
                clearable
                :placeholder="$t('GlobalSetObj.pleaseInput')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 请求时间 -->
            <el-form-item :label="$t('orderCenterCont.RequestTime')">
              <el-date-picker
                v-model="queryForm.params.requestTimes"
                type="datetimerange"
                range-separator="-"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('basicData.CustomerName')">
              <CustomerCmp :val="queryForm.params.customerId" @change="val => queryForm.params.customerId = val" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.senderZipCode')">
              <el-input
                v-model="queryForm.params.senderZipcode"
                clearable
                :placeholder="$t('GlobalSetObj.pleaseInput')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('receivablePayable.RecipientzipCode')">
              <el-input
                v-model="queryForm.params.receiveZipcode"
                clearable
                :placeholder="$t('GlobalSetObj.pleaseInput')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-button
        type="primary" size="small" icon="el-icon-search"
        @click="onQuery"
      >{{
        $t('operationCenter.Procurar')
      }}
      </el-button>
      <el-button size="small" icon="el-icon-refresh-left" @click="reset">{{
        $t('operationCenter.reset')
      }}
      </el-button>
    </el-card>

    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :height="tableHeightRow.height"
      >
        <el-table-column :label="$t('operationCenter.ind')" width="80px" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <!-- 业务单号 -->
        <el-table-column :label="$t('receivablePayable.TicketNumber')" prop="businessNumber" />

        <!-- 请求时间 -->
        <el-table-column :label="$t('orderCenterCont.RequestTime')" prop="createTime" />

        <!-- 用户 -->
        <el-table-column :label="$t('routes.usernameLabel')" prop="createUserName" />

        <!-- 客户 -->
        <!--        <el-table-column :label="$t('basicData.CustomerName')" prop="customerName" />-->

        <!-- 发进入邮编 -->
        <!--        <el-table-column :label="$t('collectionCenter.senderZipCode')" prop="senderZipcode" />-->

        <!-- 收件人邮编 -->
        <!--        <el-table-column :label="$t('receivablePayable.RecipientzipCode')" prop="receiveZipcode" />-->

        <!-- 请求状态 -->
        <!-- <el-table-column :label="$t('receivablePayable.TicketNumber')" prop="logisticsNumber" /> -->

        <el-table-column
          :label="$t('GlobalSetObj.operate')"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleClick(scope.row)">{{ $t('GlobalSetObj.View') }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[50, 100, 200, 500]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getTableData"
          @size-change="getTableData"
        />
      </div>
    </el-card>

    <!-- 详情 -->
    <el-drawer
      :visible.sync="detailsRow.isShow"
      :close-on-click-modal="false"
      :append-to-body="true"
      direction="ltr"
      size="70%"
      custom-class="drawerClass"
      :title="$t('orderCenterCont.ViewDetails')"
    >
      <DetailsCmp :row="detailsRow.row" />
    </el-drawer>
  </div>
</template>

<script>
import { apiCarlosRequestLogPage } from '@/api/finance/basicData';
import { formData, setDisabledDate } from './utils';
import DetailsCmp from './cmp/DetailsCmp';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash-es';

const PARAMS = {
  businessNumber: '',
  requestTimes: '',
  customerId: '',
  receiveZipcode: '', // 收件人邮编
  senderZipcode: '' // 发件人邮编
};

export default {
  components: {
    DetailsCmp,
    CustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      queryForm: {
        orderDirection: 'DESC',
        orderProperty: '',
        pageNumber: 1,
        pageSize: 100,
        params: {
          ...PARAMS
        }
      },
      total: 0,
      tableData: [],

      // 详情
      detailsRow: {
        isShow: false,
        row: {
          ...formData
        }
      },

      choiceDate0: '',
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          return setDisabledDate(time, this.choiceDate0, 6);
        }
      }
    };
  },

  created() {
    this.setParams();
  },

  methods: {
    onQuery() {
      this.getTableData();
    },

    // 重置
    reset() {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 100;
      this.queryForm.params = {
        ...PARAMS
      };
      this.setParams();
      this.onQuery();
    },

    setParams() {
      // 设置默认时间
      const firstDay = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
      const lastDay = dayjs().format('YYYY-MM-DD') + ' 23:59:59';
      this.queryForm.params.requestTimes = [firstDay, lastDay];
    },

    // 设置查询条件
    setQueryForm() {
      const queryForm = cloneDeep(this.queryForm);
      const { requestTimes } = this.queryForm.params;

      if (!Array.isArray(requestTimes)) {
        queryForm.params.requestTimes = [];
      }

      return queryForm;
    },

    getTableData() {
      const obj = this.setQueryForm();
      apiCarlosRequestLogPage(obj).then(res => {
        const { code, data } = res;
        if (code !== 200) return;
        const { records, total } = data;
        this.total = total;

        this.tableData = records || [];
      }).catch((err) => {
        console.log(err);
      });
    },

    // 查看详情
    handleClick(row) {
      this.detailsRow.isShow = true;
      Object.assign(this.detailsRow.row, { ...row });
    }
  }

};
</script>
